import { createAttachmentId } from './createAttachmentId'

/**
 * @param {import('@/pages/Documents/documentsDemoData').DocumentItem} item
 */
export function createFileFromDocumentItem(item) {
  return new File([new Blob()], item.name, { type: 'application/octet-stream' })
}

/**
 * @param {import('@/pages/Documents/documentsDemoData').DocumentItem} item
 */
export function createAttachmentFromDocumentItem(item) {
  const file = createFileFromDocumentItem(item)
  return {
    id: createAttachmentId(),
    file,
    documentId: item.id,
    // Already in the user's library: removing the chip must not delete it.
    fromLibrary: true,
  }
}
